var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29187 0.748907C2.84054 0.720548 2.3888 0.79749 1.97229 0.973639C1.55578 1.14979 1.18594 1.42033 0.891909 1.76392C0.271231 2.57949 -0.0428307 3.58737 0.00470196 4.61115C0.0522346 5.63493 0.458282 6.60935 1.15186 7.3639L1.66791 7.9499L6.32788 13.2499L10.9859 7.9499L11.5019 7.3639C12.1955 6.60935 12.6016 5.63493 12.6491 4.61115C12.6966 3.58737 12.3826 2.57949 11.7619 1.76392C10.4719 0.294922 8.27887 0.42791 6.84387 2.06391L6.32788 2.6529L5.80988 2.06391C5.49831 1.68873 5.11527 1.37926 4.68299 1.15351C4.2507 0.927754 3.7778 0.790213 3.29187 0.748907Z",
    fill: "#F9F9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3dc350cc09c454c7dbaa4f2800a1f078.svg";
export { ForwardRef as ReactComponent };